export default __webpack_public_path__ + "static/media/slider-kingdom.8969ec68.png";